<template>
    <div class="col-12">
        <div class="shop_item shop_item-service"
             @click="openService(this.item.id)">
            <div v-if="item.badge !== undefined"
                 class="shop_item-service_badge shop_item-badge"
                 :class="'badge-'+this.item.badge.color"
            >
                {{this.item.badge.text}}
            </div>
            <div class="shop_item-service_data">
                <div class="shop_item-service_title">
                    {{this.item.name}}
                </div>
                <div class="shop_item-service_count">
                    {{ visits }}
                </div>
            </div>
            <div class="shop_item-service_price">
                <div class="shop_item-service_price-value">
                    <currency-symbol :price="this.item.price"/>
                </div>
                <div class="shop_item-service_price-btn">
                    <img src="../../assets/img/arrow.svg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {plural} from "../../utilities";
    import api from "../../api";
    import CurrencySymbol from "../CurrencySymbol";

    export default {
        name: "ShopServiceListItem",
        components: {CurrencySymbol},
        props: {
            item: [],
        },
        computed: {
            visits() {
                return plural(this.item.visits_limit, ['посещение', 'посещения', 'посещений'])
            },
        },
        methods: {
            async openService(itemId) {
                this.$store.commit('SHOW_MODAL_PRELOADER')
                let item = (await api.shop.getCatalogService(itemId)).data;
                this.$store.commit('SET_SHOP_ITEM_SERVICE_MODAL', item)
                this.$store.commit('HIDE_MODAL_PRELOADER')
            },
        },
    }
</script>